<template>
  <el-radio-group
    v-if="radioView && isDesktop"
    v-model="value"
    class="desktop"
    :disabled="disabled"
    @update:modelValue="update"
  >
    <el-radio-button v-if="withEmpty" key="all" :value="0">
      All types
    </el-radio-button>
    <el-radio-button
      v-for="item in lables"
      :key="item.stream"
      :value="item.stream"
    >
      {{ item.label }}
    </el-radio-button>
  </el-radio-group>
  <el-select
    v-else
    v-model="value"
    :disabled="disabled"
    :multiple="multiple"
    :placeholder="label"
    size="default"
    @update:modelValue="update"
  >
    <el-option
      v-if="withEmpty && !multiple"
      key="all"
      label="All streams"
      :value="null"
    >
      All streams
    </el-option>
    <el-option
      v-for="item in lables"
      :key="item.stream"
      :label="item.label"
      :value="item.stream"
    >
      <StreamIcon :stream-id="item.stream" />
      {{ item.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, computed, ref, watch } from 'vue'
import StreamIcon from '@/components/StreamIcon.vue'
import { StreamLabels } from '@/api/types'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'StreamSelect',
  components: {
    StreamIcon
  },
  props: {
    label: {
      type: String,
      default: 'Select stream'
    },
    modelValue: {
      default: null,
      type: [Number, Array]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    withEmpty: {
      type: Boolean,
      default: true
    },
    radioView: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = function (newValue: any) {
      if (props.multiple) {
        const parsedValue = newValue.map((x: any) => parseInt(x))
        context.emit('update:modelValue', parsedValue)
      } else {
        if (newValue !== null) {
          newValue = parseInt(newValue)
        }
        context.emit('update:modelValue', newValue)
      }
    }

    const lables = computed(() => {
      return props.items.length > 0 ? props.items : StreamLabels
    })

    const { isDesktop } = useResize()

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { update, lables, isDesktop, value }
  }
})
</script>
